'use strict';

module.exports = function($timeout) {
    var alertsStack = [];

    return {
        error: function(msg) {
            alertsStack.push({
                type: 'danger',
                msg: msg,
                code: 'error',
                timeout: 3000
            });
        },
        errorNoTimeout: function(msg) {
            alertsStack.push({
                type: 'danger',
                msg: msg,
                code: 'error',
                timeout: 99999 //Infinity
            });
        },
        loading: function(msg, uid, timeout) {
            // Solo permitimos un toast de carga a la vez en toda la página.
            // Usamos una variable global de window para poder chequear este estado
            // desde cualquier parte de la aplicación.
            if (window.loadingToastShowing) {
                return;
            }
            window.loadingToastShowing = true;
            alertsStack.push({
                type: 'info',
                msg: msg,
                code: 'loading',
                timeout: timeout || 30000,
                uid: uid
            });
            // invokeApply en false: programamos con Angular pero evitamos un digest
            // innecesario, ya que solo modificamos una variable de window.
            $timeout(function() {
                window.loadingToastShowing = false;
            }, 3000, false);
        },
        success: function(msg) {
            alertsStack.push({
                type: 'success',
                msg: msg,
                code: 'success',
                timeout: 3000
            });
        },
        closeAlert: function(index) {
            alertsStack.splice(index, 1);
        },
        closeLoaders: function(uid) {
            $timeout(function() {
                alertsStack = alertsStack.filter(function(alert) {
                    if (!alert.uid) {
                        return true;
                    }
                    return alert.uid !== uid;
                });
            }, 500);
        },
        get: function() {
            return alertsStack;
        },
    };
};
